// extracted by mini-css-extract-plugin
export var actions = "_4g-0";
export var actionsContainer = "_4g-7";
export var border = "_4g-1";
export var childFullHeight = "_4g-e";
export var collapse = "_4g-2";
export var content = "_4g-9";
export var contentChild = "_4g-d";
export var fullscreen = "_4g-b";
export var hasLeftRadius = "_4g-q";
export var headerContainer = "_4g-3";
export var headerRow = "_4g-5";
export var hidePadding = "_4g-a";
export var navCollapsedGap = "_4g-r";
export var noScrollX = "_4g-s";
export var noScrollY = "_4g-t";
export var noTopPadding = "_4g-o";
export var optOutTopPadding = "_4g-c";
export var outletContent = "_4g-k";
export var outletContentInner = "_4g-l";
export var outletLeadingPanel = "_4g-h";
export var outletLeadingPanelAttention = "_4g-i";
export var outletResizeDivider = "_4g-j";
export var outletSplit = "_4g-f";
export var outletSplitResizing = "_4g-g";
export var pageMain = "_4g-p";
export var pageOuter = "_4g-m";
export var pagePadding = "_4g-8";
export var profile = "_4g-u";
export var profileContainer = "_4g-v";
export var profileImage = "_4g-w";
export var profileMain = "_4g-x";
export var profileSubtitle = "_4g-z";
export var profileTitle = "_4g-y";
export var showLeftPadding = "_4g-n";
export var tabsPortalSlot = "_4g-6";
export var tabsWrapper = "_4g-4";
export var title = "_4g-10";